<div class="dialog-container" data-automation="premo-dialog">
    <premo-loader></premo-loader>
    <div class="text-center">
        <h1 mat-dialog-title data-automation="dialog-title">{{ data.title }}</h1>
        <div mat-dialog-content>
            <p data-automation="dialog-content-text">{{ data.contentText }}</p>
        </div>
        <div mat-dialog-actions class="flex items-center justify-evenly">
            <button
                class="icon-btn secondary-btn"
                data-automation="dialog-first-button"
                matRipple
                (click)="data.firstButtonCallback()"
            >
                <span> {{ data.firstButtonText }}</span>
            </button>
            <button
                class="icon-btn primary-btn first-button"
                *ngIf="data.secondButtonText"
                data-automation="dialog-second-button"
                matRipple
                (click)="data.secondButtonCallback()"
            >
                <span> {{ data.secondButtonText }}</span>
            </button>
        </div>
    </div>
</div>
